import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { TabNav } from "../../../components/navs/tabNav";
import { PageHeader } from "../../../components/typography/pageHeader";
import { useGetUserProfileQuery } from "../../../redux/features/auth/auth.api";
import { useAppSelector } from "../../../redux/hooks";
import { BankAccount } from "./bankAccountSettings";
import { Configurations } from "./configurations";
import { CooperativeOfficials } from "./cooperativeOfficials";
import { MembershipSettingsView } from "./membershipSettings/view";
import { ProfileView } from "./profileSettings/profileView";
import { RolesAndApprovals } from "./rolesApprovals";
import { Security } from "./security";

type SettingsType =
  | "profile"
  | "bank_account"
  | "configurations"
  | "manage_officials"
  | "roles_and_approvals"
  | "membership_settings"
  | "security"
  | "profile"
  | "bank_account"
  | "security";

export const Settings = () => {
  const [tab, setTab] = useState<SettingsType>();

  const [searchParams, setSearchParams] = useSearchParams();

  const { profile } = useAppSelector((state) => {
    return state.auth;
  });

  useGetUserProfileQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const tabNavs: {
    title: string;
    to: SettingsType;
  }[] =
    profile?.type === "cooperative"
      ? [
          {
            title: "Profile",
            to: "profile",
          },
          {
            title: "Bank Account",
            to: "bank_account",
          },
          {
            title: "Configurations",
            to: "configurations",
          },
          {
            title: "Manage Officials",
            to: "manage_officials",
          },
          {
            title: "Roles & Approvals",
            to: "roles_and_approvals",
          },
          {
            title: "Membership Settings",
            to: "membership_settings",
          },
          {
            title: "Security",
            to: "security",
          },
        ]
      : [
          {
            title: "Profile",
            to: "profile",
          },
          {
            title: "Bank Account & Cards",
            to: "bank_account",
          },
          {
            title: "Security",
            to: "security",
          },
        ];

  useEffect(() => {
    const predefinedTab = searchParams.get("tab") as SettingsType;

    setTab(predefinedTab ?? "profile");
    // eslint-disable-next-line
  }, [searchParams]);

  return (
    <div className="">
      <PageHeader
        pageTitle={`Settings`}
        hasBack={false}
        onBackClick={() => {}}
        className="max-md:hidden"
      />

      <TabNav
        navs={tabNavs.map((t) => ({
          ...t,
          onClick: (val) => {
            setSearchParams({ tab: val as SettingsType });
          },
        }))}
        className="md:mt-6 w-full md:w-fit overflow-scroll"
        activeTab={tab ?? ""}
        variant="nav"
      />

      <div className="mt-7">
        {tab === "profile" && <ProfileView />}

        {tab === "bank_account" && <BankAccount />}

        {tab === "manage_officials" && profile?.type === "cooperative" && (
          <CooperativeOfficials />
        )}

        {tab === "roles_and_approvals" && profile?.type === "cooperative" && (
          <RolesAndApprovals />
        )}

        {tab === "membership_settings" && profile?.type === "cooperative" && (
          <MembershipSettingsView />
        )}

        {tab === "configurations" && profile?.type === "cooperative" && (
          <Configurations />
        )}

        {tab === "security" && <Security />}
      </div>
    </div>
  );
};
